import { render, staticRenderFns } from "./GroupsMenu.vue?vue&type=template&id=1638d518&scoped=true"
import script from "./GroupsMenu.vue?vue&type=script&lang=js"
export * from "./GroupsMenu.vue?vue&type=script&lang=js"
import style0 from "./GroupsMenu.vue?vue&type=style&index=0&id=1638d518&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1638d518",
  null
  
)

export default component.exports